import { convertWktToPointsArr, getArea } from "../../../../common/gisUtils";
import { addMeasurementsFromPoints, findCurrentEPSGUnitUsingPClouds, updateZValueForAOI } from "../../../../common/potreeUtils";
import { DataAOI } from "../../../../types/interfaces";
import * as turf from "@turf/turf";

export const getAOIDataFromH3Index = (data: any, inH3Index: string) => {
    return data.find((item: any) => item.h3_index === inH3Index);
}

export const addAOIToPotree = (aoi: DataAOI) => {
    let points3d = convertWktToPointsArr(aoi.polygon)


    let measure = addMeasurementsFromPoints(points3d)
    measure.userData.h3_index = aoi.h3_index
    measure.userData.name = aoi.name || aoi.h3_index
    updateZValueForAOI(aoi)
    return measure
}

export const processAOIDataFromLambda = (inAOIs: any) => {
    let activeProjection = window.activeProjection?.getCRS()
    
    // Filter out AOIs that are not in the active projection
    const aois = inAOIs.filter((aoi: any) => aoi.crs === activeProjection)

    let data: any = []
    aois.forEach((aoi: any) => {
        // Convert WKT to points for Potree
        let points2d = convertWktToPointsArr(aoi.polygon)

        // Remove last point as wkt needs first and last point to be the same, but Potree doesn't
        points2d.pop()
        const area = getArea(points2d)
        const unit = findCurrentEPSGUnitUsingPClouds()
        const areaText = area.toFixed(2) + " " + unit + "²"

        let name = aoi.name || aoi.h3_index

        data.push({
            "area": area,
            "areaText": areaText,
            "epsg": aoi.crs,
            "name": name,
            "visible": false,
            "polygon": aoi.polygon,
            "webMercatorPolygon": aoi.web_mercator_polygon,
            "h3_index": aoi.h3_index || ""
        })
    });
    return data
}

export const getIntersectedDataWithAOIUsingBBox = (dataIds : string[], aoiPoints:any[], inAOI : DataAOI) => {
    const points = aoiPoints.map((point: any) => [point[0], point[1]])
    if(points.length < 3) return {}

    points.push(points[0])

    const potreeViewer = window.potreeViewer

    let pClouds : any[] = []
    dataIds.forEach((id: string) => {
        const pCloud = potreeViewer.scene.pointclouds.find((pCloud: any) => id === pCloud?.record?.data_id)
        if (pCloud) {
            pClouds.push(pCloud)
        }
    })
    pClouds = pClouds.filter((pCloud: any) => pCloud.boundingBox)
    const intersectionData : any[] = []
    pClouds.forEach((pCloud: any) => {
        const boundingBox = pCloud.boundingBox
        if(!boundingBox) return
        
        const boxPolygon = [
            [boundingBox.min.x, boundingBox.min.y],
            [boundingBox.min.x, boundingBox.max.y],
            [boundingBox.max.x, boundingBox.max.y],
            [boundingBox.max.x, boundingBox.min.y],
            [boundingBox.min.x, boundingBox.min.y]
        ]
        const poly = turf.polygon([points])
        const boxPoly = turf.polygon([boxPolygon])
        const intersection = turf.intersect(poly, boxPoly)
        
        if(!intersection) return
        intersectionData.push(pCloud)
    })
    const data :any = {}

    intersectionData.forEach((pCloud: any) => {
        const dataId = pCloud.record.data_id
        const owner_id = pCloud.record.owner_id
        if(!data[owner_id]) data[owner_id] = []
        data[owner_id].push(dataId)
    })
    return data
}
